/**
 * Marketplace root for the running host. Preview tunnels change hostname;
 * never keep a stale localhost URL in the browser.
 */
export const stripTrailingSlash = url => (typeof url === 'string' ? url.replace(/\/$/, '') : '');

export const runtimeMarketplaceRootURL = (
  fallback,
  location = typeof window !== 'undefined' ? window.location : undefined
) => {
  if (location?.origin) {
    return stripTrailingSlash(location.origin);
  }
  return stripTrailingSlash(fallback);
};

/**
 * Console top-bar.json can point the logo at a marketing host (sweetlisteners.com).
 * On TEST previews that would leave the current marketplace — only keep the
 * hosted href when it is the same origin as this page.
 */
export const logoLinkIfSameHost = (
  logoLink,
  marketplaceRootURL,
  location = typeof window !== 'undefined' ? window.location : undefined
) => {
  const href = logoLink?.href;
  if (!href || typeof href !== 'string') {
    return null;
  }
  const root = runtimeMarketplaceRootURL(marketplaceRootURL, location);
  if (!root) {
    return null;
  }
  try {
    const pageOrigin = new URL(root.endsWith('/') ? root : `${root}/`).origin;
    const linkOrigin = new URL(href, `${pageOrigin}/`).origin;
    return linkOrigin === pageOrigin ? logoLink : null;
  } catch (e) {
    return null;
  }
};
